import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalArriendoVehiculoService } from './modal-arriendo-vehiculo.service';
import { VehiculoEntry } from 'src/app/shared/entrys/vehiculo.entry';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { Subscription } from 'rxjs';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { SolicitudService } from '../../containers/bandeja-principal/prestador/solicitudes/solicitud.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-modal-arriendo-vehiculo',
	templateUrl: './modal-arriendo-vehiculo.component.html',
	styleUrls: ['./modal-arriendo-vehiculo.component.scss']
})
export class ModalArriendoVehiculoComponent implements OnInit {
	modalGenerico: ModalGenericoModel;
	formVehiculo: FormGroup;
	headersVehiculo: Array<string>;

	marcasVehiculo: Array<any> = [];
	lineasVehiculo: Array<any> = [];
	dataTabla: DatoPaginadoModel;

	selectVehiculo: VehiculoEntry = null;
	rnt: RNTPrestadorEntry;
	subscription: Subscription;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	paginaActual: number;

	constructor(private formBuilder: FormBuilder, private dataSharedService: DataSharedService, private activeModal: NgbActiveModal,
		private modalArriendoVehiculoService: ModalArriendoVehiculoService, private solicitudService: SolicitudService) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.rnt = {} as RNTPrestadorEntry;
		this.dataSharedService.data$.subscribe(resultado => {
			this.datoSolicitudSharedModel = resultado as DatoSolicitudSharedModel;
			this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		});

		this.paginaActual = 1;

	}

	ngOnInit() {
		this.headersVehiculo = ['Marca', 'Línea', 'Placa', 'Color', 'Acción'];
		this.modalArriendoVehiculoService.getMarcas(null).subscribe(resultado => {
			if (resultado.result) {
				this.marcasVehiculo = resultado.data as Array<any>;
			}
		});

		this.createForm();
		if (this.rnt.detalle_solicitud_id) {
			this.onConsultarVehiculosAnteriores(1);
		} else {
			this.solicitudService.get(this.rnt).subscribe(resultado => {
				if (resultado.result) {
					this.rnt.detalle_solicitud_id = resultado.data.detalle_solicitud_id;
					this.onConsultarVehiculosAnteriores(1);
				}
			});
		}
	}

	createForm() {
		this.formVehiculo = this.formBuilder.group({
			marca_id: [null, Validators.required],
			linea_id: [null, Validators.required],
			placa: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(7)]],
			color: ['', Validators.required],
			vehiculo_id: [''],
			codigo_camara: [''],
			detalle_solicitud_id: [''],
			activo: [true]
		});
	}

	onChangeMarca(marca_id: number) {
		if (this.formVehiculo.get('marca_id').value != null && this.formVehiculo.get('marca_id').value !== 0) {
			this.modalArriendoVehiculoService.getLineas(null, marca_id).subscribe(resultado => {
				if (resultado.result) {
					this.lineasVehiculo = resultado.data as Array<any>;
				}
			});
		}
	}
	//#region Capacidad Tecnica
	onAgregarVehiculo() {
		this.modalArriendoVehiculoService.crearVehiculo({
			...this.formVehiculo.value,
			codigo_camara: this.rnt.codigo_camara,
			detalle_solicitud_id: this.rnt.detalle_solicitud_id,
			activo: true
		})
			.subscribe(res => {
				if (res.result) {
					this.onConsultarVehiculosAnteriores(1);
					this.formVehiculo.reset();
				}
			});

	}

	onModificarVehiculo() {
		this.modalArriendoVehiculoService.update(this.formVehiculo.value).subscribe(resultado => {
			if (resultado.result) {
				this.formVehiculo.reset();
				this.selectVehiculo = null;
				this.onConsultarVehiculosAnteriores(1);
			}
		});
	}

	onConsultarVehiculosAnteriores(page: number) {
		this.modalArriendoVehiculoService.getVehiculos(page, {
			...this.formVehiculo.value,
			codigo_camara: this.rnt.codigo_camara,
			detalle_solicitud_id: this.rnt.detalle_solicitud_id
		}).subscribe(res => {
			if (res.result) {
				this.dataTabla = res.data as DatoPaginadoModel;
			}
		});
	}

	onEliminarVehiculo(entry: VehiculoEntry) {
		this.modalArriendoVehiculoService.delete(entry).subscribe(resultado => {
			if (resultado.result) {
				this.onConsultarVehiculosAnteriores(1);
				this.selectVehiculo = null;
				this.formVehiculo.reset();
			}
		});
	}

	onCargarEditarVehiculo(entry: VehiculoEntry) {
		this.formVehiculo.setValue({
			marca_id: entry.marca_id,
			linea_id: entry.linea_id,
			placa: entry.placa,
			color: entry.color,
			detalle_solicitud_id: entry.detalle_solicitud_id,
			codigo_camara: entry.codigo_camara,
			vehiculo_id: entry.vehiculo_id,
			activo: true
		});

		this.selectVehiculo = entry;
	}


	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarVehiculosAnteriores(value);
	}
	onDismiss() {
		this.activeModal.dismiss();
	}
}
